import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { StockService } from '../share/services/stock/stock.service';
import { MasterMakeService } from '../share/services/master-make/master-make.service';
import { MasterModelService } from '../share/services/master-model/master-model.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { faRotate, faPlus, faSpinner, faArrowLeft, faTrash } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-sku-merge',
  templateUrl: './sku-merge.component.html',
  styleUrl: './sku-merge.component.scss',
  standalone: false
})
export class SkuMergeComponent implements OnInit {

  @ViewChild('mergeConfirmModal') mergeConfirmModal!: TemplateRef<any>;

  protected faRotate = faRotate;
  protected faPlus = faPlus;
  protected faSpinner = faSpinner;
  protected faArrowLeft = faArrowLeft;
  protected faTrash = faTrash;

  isCreateMode: boolean = false;

  mergeList: any[] = [];
  mergingInProgressList: any[] = [];
  mergingCompletedList: any[] = [];
  isAnyMergingInProgress: boolean = false;
  loader: boolean = false;
  errMessage: string = '';
  listPage: number = 0;
  endOfResults: boolean = false;

  selectedTireSize: any = null;
  selectedBrand: any = null;
  selectedPattern: any = null;
  addedSkusList: any[] = [];

  tyreSizeList: any[] = [];
  tyreSizeObj: any = { page: 0 };
  
  tyreMakeList: any[] = [];
  tyreMakeObj: any = { page: 0 };
  
  tyreModelList: any[] = [];
  tyreModelObj: any = { page: 0 };
  filteredModelList: any[] = [];

  selectedTargetModel: string = '';
  isPermanentConfirmed: boolean = false;
  mergeReason: string = '';
  private modalRef: any = null;

  saveLoader: boolean = false;
  saveErrMessage: string = '';
  toasterMsg: string = '';

  customSearchFn = () => true;

  constructor(
    private readonly stockService: StockService,
    private readonly masterMakeService: MasterMakeService,
    private readonly masterModelService: MasterModelService,
    private readonly modalService: NgbModal
  ){}

  ngOnInit(): void {
    this.getMergeList();
  }

  getMergeList(): void {
    this.loader = true;
    this.errMessage = '';
    this.masterModelService.getMergeSkulist(this.listPage).subscribe({
      next: (res: any) => {
        this.loader = false;
        let rawList = [];
        if (res) {
          if (Array.isArray(res)) {
            rawList = res;
          } else if (res.data) {
            rawList = Array.isArray(res.data) ? res.data : (res.data.result || []);
          } else if (res.result) {
            rawList = Array.isArray(res.result) ? res.result : [];
          }
        }
        
        if (this.listPage === 0) {
          this.mergeList = rawList;
        } else {
          this.mergeList = [...this.mergeList, ...rawList];
        }

        if (rawList.length === 0) {
          this.endOfResults = true;
        }
        this.splitList();
      },
      error: (err: any) => {
        this.loader = false;
        this.errMessage = err?.error?.message || err?.error?.error?.message || 'Failed to load merge records.';
        this.mergeList = [];
        this.splitList();
      }
    });
  }

  refreshList(): void {
    this.listPage = 0;
    this.endOfResults = false;
    this.mergeList = [];
    this.mergingCompletedList = [];
    this.mergingInProgressList = [];
    this.getMergeList();
  }

  splitList() {
    this.mergingInProgressList = this.mergeList.filter(item => {
      const status = (item.status || '').toLowerCase();
      return status === 'pending' || status === 'processing';
    });
    
    this.mergingCompletedList = this.mergeList.filter(item => {
      const status = (item.status || '').toLowerCase();
      return status === 'completed' || status === 'failed' || status === 'success';
    });

    this.isAnyMergingInProgress = this.mergingInProgressList.length > 0;
  }

  initDropdownData() {
    this.getTyreSize();
    this.getTyreMake();
  }

  getTyreSize() {
    this.stockService.getTyreDetails(this.tyreSizeObj).subscribe({
      next: (res: any) => {
        if (this.tyreSizeObj.page === 0) {
          this.tyreSizeList = res.data || [];
        } else {
          this.tyreSizeList = [...this.tyreSizeList, ...(res.data || [])];
        }
      }
    });
  }

  scrollTyreSize() {
    this.tyreSizeObj.page++;
    this.getTyreSize();
  }

  onTyreSizeInputChange(event: any) {
    this.tyreSizeObj.page = 0;
    this.tyreSizeObj.searchTerm = event.term;
    this.tyreSizeList = [];
    this.getTyreSize();
  }

  getTyreMake() {
    this.masterMakeService.getTyreMakeBySize(this.tyreMakeObj.page, this.tyreMakeObj.searchTerm).subscribe({
      next: (res: any) => {
        if (this.tyreMakeObj.page === 0) {
          this.tyreMakeList = res.data || [];
        } else {
          this.tyreMakeList = [...this.tyreMakeList, ...(res.data || [])];
        }
      }
    });
  }

  onTyreMakeInputChange(event: any) {
    this.tyreMakeObj.page = 0;
    this.tyreMakeObj.searchTerm = event.term;
    this.tyreMakeList = [];
    this.getTyreMake();
  }

  onMakeSelected() {
    let option = this.selectedBrand;
    if (option) {
      this.selectedPattern = null;
      this.tyreModelObj.tyreMake = option;
      this.tyreModelObj.name = '';
      this.tyreModelObj.page = 0;
      this.tyreModelList = [];
      this.filteredModelList = [];
      this.getTyreModel();
    }
  }

  getTyreModel() {
    this.masterModelService.getTyreModelList(this.tyreModelObj).subscribe({
      next: (res: any) => {
        if (this.tyreModelObj.page === 0) {
          this.tyreModelList = res.data || [];
        } else {
          this.tyreModelList = [...this.tyreModelList, ...(res.data || [])];
        }
        this.updateFilteredModels();
      }
    });
  }

  scrollTyreModel() {
    this.tyreModelObj.page++;
    this.getTyreModel();
  }

  onTyreModelInputChange(event: any) {
    this.tyreModelObj.page = 0;
    this.tyreModelObj.name = event.term;
    this.tyreModelList = [];
    this.getTyreModel();
  }

  onSizeClose() {
    if (this.tyreSizeObj.searchTerm) {
      this.tyreSizeObj.page = 0;
      this.tyreSizeObj.searchTerm = '';
      this.getTyreSize();
    }
  }

  onMakeClose() {
    if (this.tyreMakeObj.searchTerm) {
      this.tyreMakeObj.page = 0;
      this.tyreMakeObj.searchTerm = '';
      this.getTyreMake();
    }
  }

  onModelClose() {
    if (this.tyreModelObj.name) {
      this.tyreModelObj.page = 0;
      this.tyreModelObj.name = '';
      this.getTyreModel();
    }
  }

  updateFilteredModels() {
    if (!this.tyreModelList) {
      this.filteredModelList = [];
      return;
    }
    this.filteredModelList = this.tyreModelList.filter(model => 
      !this.addedSkusList.some(added => added.model === model.name)
    );
  }

  addSkuToList() {
    if (this.selectedTireSize && this.selectedBrand && this.selectedPattern) {
      this.addedSkusList.push({
        size: this.selectedTireSize,
        make: this.selectedBrand,
        model: this.selectedPattern,
        label: `${this.selectedTireSize} ${this.selectedBrand} ${this.selectedPattern}`
      });
      this.selectedPattern = null;
      this.updateFilteredModels();
    }
  }

  removeSkuFromList(index: number) {
    this.addedSkusList.splice(index, 1);
    this.updateFilteredModels();
  }

  openMergeConfirmModal(content: any) {
    this.saveErrMessage = '';
    this.saveLoader = false;
    this.isPermanentConfirmed = false;
    this.mergeReason = '';
    if (this.addedSkusList.length > 0) {
      this.selectedTargetModel = this.addedSkusList[0].model;
    } else {
      this.selectedTargetModel = '';
    }
    this.modalRef = this.modalService.open(content, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
      size: 'md'
    });
  }

  submitMerge() {
    if (this.addedSkusList.length < 2 || !this.isPermanentConfirmed || !this.mergeReason.trim()) return;
    
    this.saveLoader = true;
    this.saveErrMessage = '';
    const firstItem = this.addedSkusList[0];
    const payload = {
      tyreMake: firstItem.make,
      tyreSize: firstItem.size,
      sourceModels: this.addedSkusList.map(item => item.model),
      targetModel: this.selectedTargetModel,
      reason: this.mergeReason.trim()
    };
    this.masterModelService.createMerge(payload).subscribe({
      next: (res: any) => {
        this.saveLoader = false;
        this.toasterMsg = 'SKUs merged successfully';
        
        if (this.modalRef) {
          this.modalRef.close();
        }
        
        this.addedSkusList = [];
        this.selectedTireSize = null;
        this.selectedBrand = null;
        this.selectedPattern = null;
        this.updateFilteredModels();
        
        this.listPage = 0;
        this.endOfResults = false;
        this.isCreateMode = false;
        this.getMergeList();
      },
      error: (error: any) => {
        this.saveLoader = false;
        this.saveErrMessage = error?.error?.message || error?.error?.error?.message || 'Something went wrong while merging SKUs';
      }
    });
  }

  toggleCreateMode(mode: boolean) {
    this.isCreateMode = mode;
    this.saveErrMessage = '';
    
    if (mode) {
      this.addedSkusList = [];
      this.selectedTireSize = null;
      this.selectedBrand = null;
      this.selectedPattern = null;
      this.updateFilteredModels();
      this.initDropdownData();
    } else {
      this.listPage = 0;
      this.endOfResults = false;
      this.getMergeList();
    }
  }

  onScrollList() {
    if (this.endOfResults || this.loader) return;
    this.listPage++;
    this.getMergeList();
  }

  formatSku(sku: any): string {
    if (!sku) return '';
    if (typeof sku === 'string') return sku;
    const parts = [];
    if (sku.size) parts.push(sku.size);
    if (sku.make) parts.push(sku.make);
    if (sku.model) parts.push(sku.model);
    return parts.join(' · ');
  }

  formatSources(sources: any): string {
    if (!sources) return '';
    if (typeof sources === 'string') return sources;
    if (Array.isArray(sources)) {
      return sources.map(s => this.formatSku(s)).join(', ');
    }
    return '';
  }

  getTargetSkuLabel(item: any): string {
    if (!item) return '';
    if (item.targetSku) {
      return this.formatSku(item.targetSku);
    }
    const parts = [];
    if (item.tyreSize) parts.push(item.tyreSize);
    if (item.tyreMake) parts.push(item.tyreMake);
    if (item.targetModel) parts.push(item.targetModel);
    return parts.join(' · ');
  }

  getSourcesLabel(item: any): string {
    if (!item) return '';
    if (item.sources) {
      return this.formatSources(item.sources);
    }
    if (Array.isArray(item.sourceModels)) {
      return item.sourceModels.map((model: string) => {
        const parts = [];
        if (item.tyreSize) parts.push(item.tyreSize);
        if (item.tyreMake) parts.push(item.tyreMake);
        parts.push(model);
        return parts.join(' · ');
      }).join(', ');
    }
    return '';
  }

  getStatusClass(statusStr: string): string {
    const status = (statusStr || '').toLowerCase();
    if (status === 'pending' || status === 'processing' || status === 'merging' || status === 'running') {
      return 'status-merging';
    }
    if (status === 'completed' || status === 'success') {
      return 'status-completed';
    }
    if (status === 'failed') {
      return 'status-failed';
    }
    return '';
  }

  getStatusLabel(statusStr: string): string {
    const status = (statusStr || '').toLowerCase();
    if (status === 'pending' || status === 'processing' || status === 'merging' || status === 'running') {
      return 'Merging...';
    }
    if (status === 'completed' || status === 'success') {
      return 'Completed';
    }
    if (status === 'failed') {
      return 'Failed';
    }
    return statusStr || '';
  }

}
